import styled, { css } from "styled-components";
import { Link } from "@viagogo/core/ui";
import { FavoritesButtonWithCount } from "src/website-apps/shared/components/FavoritesV2Buttons/FavoritesV2Button/FavoritesButtonWithCount";
import { Image } from "src/website-apps/shared/components/image";

export const StyledCompactCategoryCard = styled(Link)<{ $whiteBackground?: boolean }>`
  background-color: ${(props) => props.theme.colors.backgroundSecondary};
  border-radius: 12px;
  display: block;
  height: 64px;
  position: relative;
  width: auto;
  user-select: none;
  ${(props) =>
    props.$whiteBackground &&
    css`
      background-color: white;
    `}
`;

export const StyledContentContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: 16px;
  height: 100%;
  padding: ${(props) => props.theme.spacing(3, 4)};
  width: 100%;
`;

export const StyledSquareImage = styled(Image)`
  border-radius: ${(props) => props.theme.borderRadius.m};
  object-fit: cover;
`;

export const StyledMetadata = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: max-content;
  max-width: 60%;
`;

export const StyledPerformerName = styled.p`
  color: ${(props) => props.theme.colors.textStrong};
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
`;

export const StyledEventCount = styled.p`
  ${({
    theme: {
      typography: { getStyles, variant },
    },
  }) => getStyles(variant.body2)};
  color: ${(props) => props.theme.colors.textStrong};
  opacity: 0.7;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
`;

export const StyledFavoritesButton = styled(FavoritesButtonWithCount)`
  position: absolute;
  right: 16px;
`;

export const SimpleStyledCompactCategoryCard = styled(Link)<{ $searchResults?: boolean }>`
  background-color: ${(props) => props.theme.palette.surfacePrimary};
  background-color: ${(props) =>
    props.$searchResults ? props.theme.palette.surfaceSecondary : props.theme.palette.surfacePrimary};
  border-radius: 12px;
  display: block;
  height: 80px;
  position: relative;
  ${(props) =>
    props.$searchResults
      ? css`
          width: 100%;
        `
      : css`
          width: auto;
        `}
  user-select: none;

  &:hover {
    background-color: ${(props) => props.theme.palette.neutralSecondaryHover};
  }
`;

export const SimpleStyledContentContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  height: 100%;
  padding: ${(props) => props.theme.spacing(2, 3)};
  width: 100%;

  gap: 12px;
  @media ${({ theme: { media } }) => media.desktop} {
    gap: 16px;
  }
`;

export const SimpleStyledMetadata = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  height: 100%;
  width: 100%;
  max-width: 60%;
`;

export const SimpleStyledPerformerName = styled.p`
  ${({
    theme: {
      typography: { getStyles, variant },
    },
  }) => getStyles(variant.title6)};

  color: ${(props) => props.theme.colors.textStrong};
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;

export const SimpleFavoritesButtonContainer = styled.div`
  position: relative;
  width: 64px;
  height: 100%;
`;

export const SimpleStyledFavoritesButton = styled(FavoritesButtonWithCount)`
  position: absolute;
  right: 0px;
  top: ${(props) => props.theme.spacing(4)};
`;
